export default function (sentence, wordsIndexesToCapitalize = []) {
  const words = sentence.split(' ');
  const capitalizeWords = words.map((word, index) =>
    wordsIndexesToCapitalize.length === 0 || wordsIndexesToCapitalize.includes(index)
      ? word[0].toUpperCase() + word.substring(1)
      : word,
  );
  return capitalizeWords.join(' ');
}
